import { COMMON_DATA_MAP } from './index';

const getUiI18n = _ => COMMON_DATA_MAP.get('uiConfig');

export default {
    getUiI18n,
}